import api from './api';

export const testingService = {
  /**
   * Analyze pasted email content
   */
  analyzeEmail: async (emailData) => {
    const response = await api.post('/analyze_email', {
      email_data: {
        message_id: `test-${Date.now()}`,
        thread_id: `test-thread-${Date.now()}`,
        subject: emailData.subject,
        from: {
          email: emailData.from,
          name: emailData.fromName || emailData.from
        },
        to: [emailData.to],
        date: emailData.date || new Date().toISOString(),
        body_text: emailData.body,
        body_html: emailData.body,
        labels: ['INBOX'],
        snippet: emailData.body.substring(0, 100)
      },
      additional_context: emailData.additionalContext
    });
    return response.data;
  },

  /**
   * Create manual action for testing
   */
  createTestAction: async (actionData) => {
    const response = await api.post('/execute_action', {
      action_id: actionData.action_id || `test-action-${Date.now()}`,
      email_data: {
        message_id: `test-${Date.now()}`,
        thread_id: `test-thread-${Date.now()}`,
        subject: actionData.subject || 'Test Action',
        gmail_link: '#'
      },
      selected_action: {
        action_type: actionData.action_type,
        title: actionData.title,
        description: actionData.description
      },
      dry_run: actionData.dryRun || false
    });
    return response.data;
  },

  /**
   * Toggle dry run mode (stored locally)
   */
  setDryRunMode: (enabled) => {
    localStorage.setItem('dryRunMode', enabled ? 'true' : 'false');
    return enabled;
  },

  /**
   * Get dry run mode status
   */
  getDryRunMode: () => {
    return localStorage.getItem('dryRunMode') === 'true';
  }
};
